import { PreviewcomponentMap } from "./PreviewMap";
import React from "react";

type BlockProp = {
  block: any;
  index: number;
};

const ConsentBlockMinimal: React.FC<BlockProp> = ({ block, index }) => {
  const Component = PreviewcomponentMap[block.type];

  return (
    <>
      {Component && (
        <div className={"consent-block"}>
          {Component && <Component currentBlock={block} />}
        </div>
      )}
    </>
  );
};

export default React.memo(ConsentBlockMinimal);
